module.exports = __webpack_public_path__ + "static/media/wave-triangle.084310a6.svg";